import Paragraph from '@/components/common/textElements/Paragraph.tsx'
import { User } from '@/store/user.ts'
import { cn } from '@/lib/utils.ts'
import { ProjectStageUserT } from '@/components/common/menu/lib/types/projectStagesUsers.ts'
import { getAssetUrl } from '@/config/assetUrl'

type AvatarSizes = 'extraTiny' | 'tiny' | 'small' | 'medium' | 'large' | '8'
type UserAvatarVariantProps = {
  avatarUrl?: string | null
  user?: User | ProjectStageUserT | null
  size?: AvatarSizes
  className?: string
  avatarInitials?: string
}

export const UserAvatarVariant = (props: UserAvatarVariantProps) => {
  const { avatarUrl, user, className, size = 'medium', avatarInitials } = props

  const getTailwindSize = (size: AvatarSizes) => {
    switch (size) {
      case 'extraTiny':
        return 'size-4'
      case 'tiny':
        return 'size-6'
      case '8':
        return 'size-8'
      case 'small':
        return 'size-10'
      case 'medium':
      default:
        return 'size-20'
      case 'large':
        return 'size-32'
    }
  }

  const getParagraphSize = (size: AvatarSizes) => {
    switch (size) {
      case 'extraTiny':
      case 'tiny':
      case '8':
        return 'xxs'
      case 'small':
      case 'medium':
        return 'small'
      default:
        return 'base'
      case 'large':
        return 'base'
    }
  }
  return (
    <div
      id={'user-avatar-holder'}
      className={cn(
        `flex size-20 items-center justify-center rounded-full`,
        getTailwindSize(size),
        !avatarUrl && 'bg-gray-200',
        className,
      )}
    >
      {avatarUrl ? (
        <img src={getAssetUrl(avatarUrl)} alt="Avatar" className="h-full w-full rounded-full object-cover" />
      ) : (
        <Paragraph variant={'default'} size={getParagraphSize(size)}>
          {avatarInitials ?? (
            <>
              {user?.name?.[0]}
              {user?.surname?.[0]}
            </>
          )}
        </Paragraph>
      )}
    </div>
  )
}
